import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ServiceMetaComponent } from '../service-meta/service-meta.component';

interface NavItem {
  path: string;
  label: string;
  icon: string;
}

interface NavGroup {
  title: string;
  items: NavItem[];
}

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, ServiceMetaComponent],
  templateUrl: './sidebar.component.html',
})
export class SidebarComponent {
  @Input() isOpen = false;
  @Input() isCollapsed = false;
  @Output() linkClicked = new EventEmitter<void>();

  navGroups: NavGroup[] = [
    {
      title: 'Monitor',
      items: [
        { path: '/dashboard', label: 'Dashboard', icon: 'fa-th-large' },
        { path: '/kpis', label: 'KPI overview', icon: 'fa-chart-line' },
        { path: '/alerts', label: 'Alerts', icon: 'fa-bell' },
      ],
    },
    {
      title: 'Operations',
      items: [
        { path: '/hurricanes', label: 'Hurricanes', icon: 'fa-hurricane' },
        { path: '/journal', label: 'Processing journal', icon: 'fa-book' },
        { path: '/data', label: 'Recollect data', icon: 'fa-database' },
        { path: '/forecasts', label: 'Forecasts', icon: 'fa-cloud-sun' },
        { path: '/postprocessing', label: 'Postprocessing', icon: 'fa-file-import' },
        { path: '/imo-packages', label: 'IMO packages', icon: 'fa-ship' },
      ],
    },
    {
      title: 'System',
      items: [
        { path: '/config', label: 'Configuration', icon: 'fa-cog' },
        { path: '/help', label: 'Help', icon: 'fa-question-circle' },
      ],
    },
  ];
}
